export default __webpack_public_path__ + "static/media/pretzel.5b1874ba.png";